// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"dcb1888a","388":"a1672e9e"}[chunkId] + ".chunk.js";
};